import React, { useState, useEffect } from "react";
import DesktopHeaderDropdown from "./DesktopHeaderDropdown";

const HeaderDesktop = ({ menu, storeLink, labels }) => {
	if (!menu || !menu.length) return;

	const [openMenuID, setOpenMenuID] = useState(null);

	const handleClick = (id = null) => {
		if (id === openMenuID) return setOpenMenuID(null);
		setOpenMenuID(id);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			const navMenu = event.target.closest(".nav-menu");
			if (!navMenu && openMenuID !== null) {
				setOpenMenuID(null);
			}
		};

		document.addEventListener("click", handleClickOutside);

		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, [openMenuID]);

	return (
		<>
			<div className={`header--desktop nav-menu ${openMenuID !== null ? "is-open" : ""}`}>
				<ul className="nav-menu__list">
					{menu.map(({ title, id, children = [], ctas = [] }) => (
						<li key={id} className={`nav-item ${openMenuID === id ? "submenu-open" : ""}`}>
							<button className="nav-item__trigger esc-style" onClick={() => handleClick(id)}>
								{title}
							</button>
							<DesktopHeaderDropdown key={id} items={children} ctas={ctas} menuID={id} openMenuID={openMenuID} storeLink={storeLink} labels={labels} />
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

export default HeaderDesktop;
